import { Table, TableBody, TableCell, TableHead, TableRow } from '@vp/visage'
import * as React from 'react'
import { getComponentProps, PropsAutoGenType } from './prop-section.utility'
import styleClasses from './props-table.module.scss'

export type PropsTableProps = {
  component: string
}

export const PropsTypeRepresentation: React.FC<{ type: PropsAutoGenType }> = ({ type }) => {
  if (type.name === 'enum' && Array.isArray(type.value)) {
    return <TableCell>{type.value.map(({ value }) => value).join(' | ')}</TableCell>
  }
  return <TableCell>{type.name}</TableCell>
}

export default function PropsTable({ component }: PropsTableProps) {
  const componentMeta = getComponentProps(component)
  if (!componentMeta) return null

  if (Object.values(componentMeta.props).length === 0) {
    return (
      <p>
        <code>{componentMeta.displayName}</code> has no props of its own
      </p>
    )
  }

  return (
    <Table className={styleClasses.propsTable}>
      <TableHead>
        <TableRow>
          <TableCell>Prop</TableCell>
          <TableCell>Type</TableCell>
          <TableCell>Default</TableCell>
          <TableCell>Description</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.values(componentMeta.props).map(prop => {
          const { description, defaultValue, required, name, type } = prop
          return (
            <TableRow key={name}>
              <TableCell>{name}</TableCell>
              <PropsTypeRepresentation type={type} />
              <TableCell>{required ? 'required' : defaultValue?.value || ''}</TableCell>
              {description ? <TableCell dangerouslySetInnerHTML={{ __html: description }} /> : <TableCell />}
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
